import _ from "lodash";
import defaultConfig from "./default";
import {query} from 'qs'
import cookie from 'cookie'
import TpUnionLogin from "../service/tpUnionLogin";
import Progress from 'progress'

const TPChannelType = 14
module.exports = _.merge({}, defaultConfig, {
	name: '关爱通',
	isListHome: false,
	match() {
		let userAgent = navigator.userAgent
		return /guanaitong/.test(userAgent)
	},
	login() {
		let {auth_code} = query
		
		let savedCode = cookie.get('auth_code')
		
		if (!auth_code || (savedCode && savedCode === auth_code)) {
			if (cookie.get("tper") || cookie.get("pnid")) {
				return Promise.resolve()
			}
		}
		let progress = new Progress({
			hasOverlay: true,
			zIndex: 99
		})
		try {
			progress.showProgress()
		} catch (e) {
			console.log(e)
		}
		
		return TpUnionLogin.getTpUserViewByPhoneToken(TPChannelType, query.auth_code).then(() => {
			progress.hide()
			// progress = null
			cookie.set('auth_code', auth_code)
		}).catch((err) => {
			progress.showMessage(err)
			// loading = null
		})
	},
	init() {
		this.login().catch(() => {
		
		})
	}
})



// WEBPACK FOOTER //
// ./src/mods/channels/guanaitong.js